import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { DocumentDraftMainSectionProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { StyledButton, TitledContainerInner } from "components/common";
import DocumentDraftTodoSelectionFormContainer from "../forms/todoSelectionFormContainer";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { useDocumentDraftService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const DocumentDraftMainSection: React.FC<DocumentDraftMainSectionProps> = (props) => {
  const documentDraftService = useDocumentDraftService();

  const { documentDraft, formRef, onAttachmentsChange } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const onViewAllClick = () => {
    const url = documentDraftService.getDocumentUrl(documentDraft);
    if (url)
      navigate(UrlHelper.formatPath(url), {
        state: { background: location },
      });
  };

  return documentDraft.state === WintSuperkollAPIModel.DocumentDraftState.Created ? (
    <TitledContainerInner
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.SelectionPanelHeaderText)}
      subHeader={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.SelectionPanelHeaderSubText
      )}
    >
      <DocumentDraftTodoSelectionFormContainer
        ref={formRef}
        documentDraft={documentDraft}
        key={documentDraft.id}
        onAttachmentsChange={onAttachmentsChange}
      />
    </TitledContainerInner>
  ) : documentDraft.state === WintSuperkollAPIModel.DocumentDraftState.Handled ? (
    <TitledContainerInner
      header={`${documentDraftService.getTypeText(documentDraft.type)} ${LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Common.Created
      ).toLowerCase()}`}
      subHeader={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.CreatedSelectionPanelHeaderSubText,
        "",
        {
          documentType: documentDraftService.getTypeText(documentDraft.type).toLowerCase(),
          documentTypeCode: `${documentDraft.type}`,
          source: `${documentDraft.source}`,
        }
      )}
    >
      {documentDraft.entityId && documentDraft.isEntityViewable ? (
        <Grid container direction="row" spacing={1} className={cssExports.titledContainerButtons}>
          <Grid item>
            <StyledButton size="md" onClick={onViewAllClick} secondary>
              {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.View)} ${documentDraftService
                .getTypeText(documentDraft.type)
                .toLowerCase()}`}
            </StyledButton>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </TitledContainerInner>
  ) : null;
};

export default DocumentDraftMainSection;
